module.exports = __webpack_public_path__ + "static/Anant.11898e84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Anant.jpg
// module id = 1288
// module chunks = 137408898365125